module.exports = __webpack_public_path__ + "img/744.67f88efa.jpg";